<template>
    <div name="xi" class="wrapper">
        <router-view></router-view>
    </div>
</template>

<script>
// 1. 진입페이지 (동영상 플레이) 시작하기 버튼 Home
// 2. menu페이지 
// 3. 회원가입 페이지
// 4. 미리보기 페이지  -> 30초 뒤 복귀 

export default {
    name: 'xi'
}
</script>

<style scoped>
    .wrapper {
        height: 100dvh;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/page/showcase/Xi.vue